var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container"},[_c('div',{staticClass:"tile is-parent is-vertical"},[_c('div',{staticClass:"tile is-8 h-margin-center is-vertical"},[(_vm.boxData.length > 0)?_c('picBox',{attrs:{"boxes":_vm.boxData,"rbox":_vm.rBox,"lbox":_vm.lBox,"section":_vm.page}}):_vm._e(),_c('textBar',{attrs:{"params":_vm.textData}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }